/**
 * Created by FeNiX on 19-Aug-16.
 */
import React, { Component } from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";
import ServicesStore from "../stores/ServicesStore";

export default class FormEditContractor extends Component {
	constructor() {
		super();
		this.state = {
			contractor: "",
			name: "",
			color: "",
			fetching: false
		};
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleContractorChange = this.handleContractorChange.bind(this);
		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
	}
	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.post(`/contractors/${this.state.contractor}`,{name: this.state.name, color: this.state.color || null})
			.then((response)=>{
				if (response.data.updated) {
					swal("Contratante actualizado","","success");
				} else {
					swal("No hubo cambios","","info");
				}
			})
			.catch((error)=>{
				if (error.response) {
					if (error.response.status === 406) {
						if (error.response.data.name) {
							swal("Error", "Ya existe otro contratante con ese nombre","error");
						}
						if (error.response.data.color) {
							swal("Error", "Ya existe otro contratante con ese color","error");
						}
					} else {
						swal("Error", `Status: ${status}`,"error");
					}
				} else {
					console.log(error);
				}
			})
			.then(()=>{
				this.setState({fetching: false});
			})
	}
	handleContractorChange({target: {value}}) {
		this.setState({contractor: value});
		const data = this.props.contratantes.find(contratante => contratante.id == value);
		this.setState({
			name: data.name,
			color: data.color
		});
	}
	handleNameChange({target: {value}}) {
		this.setState({name: value});
	}
	handleColorChange({target: {value}}) {
		this.setState({color: value});
	}
	render() {
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Editar contratante</div>
				<div className="row">
					<div className="columns small-12">
						<div className="row">
							<label className="columns small-6">
								<em>Seleccionar</em>
								<select value={this.state.contractor} onChange={this.handleContractorChange} required>
									<option disabled value=""> --- Selectiona --- </option>
									{this.props.contratantes.map(contratante => <option value={contratante.id}>{contratante.name}</option>)}
								</select>
							</label>
						</div>
					</div>
					<label className="columns small-6">
						<em>Contrante</em>
						<input type="text" value={this.state.name} onChange={this.handleNameChange} required/>
					</label>
					<label className="columns small-2">
						<em>Color</em>
						<input type="color" value={this.state.color} onChange={this.handleColorChange}/>
					</label>
					<label className="columns small-4">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching}>Guardar</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_edit_contractor.js
 **/